var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.disabled || _vm.element.config.disabled)?_c('div',{staticClass:"input-show",style:({background: _vm.element.value})}):_c('el-color-picker',{attrs:{"recommend":""},model:{value:(_vm.element.value),callback:function ($$v) {_vm.$set(_vm.element, "value", $$v)},expression:"element.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }